import { Redirect } from "expo-router";
import React from "react";

import PageLayout from "$src/core/components/templates/PageLayout/PageLayout";
import useAuth from "$src/core/hooks/use-auth";
import LoadingPage from "$src/core/pages/LoadingPage/LoadingPage";

const Route: React.FC = () => {
  const { status, profileId } = useAuth();

  if (status === "authenticated" && profileId) {
    return (
      <PageLayout>
        <Redirect href="/storefront" />
        <LoadingPage />
      </PageLayout>
    );
  }

  if (status === "authenticated" && !profileId) {
    return (
      <PageLayout>
        <Redirect href="/profiles" />
        <LoadingPage />
      </PageLayout>
    );
  }

  return (
    <PageLayout>
      <Redirect href="/intro" />
      <LoadingPage />
    </PageLayout>
  );
};

export default Route;
